import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import MasterSelect from '@/views/components/MasterSelect.vue'
import MasterTreeselect from '@/views/components/MasterTreeselect.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('master-select', MasterSelect)
Vue.component('master-treeselect', MasterTreeselect)
